import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const DmcaDialog = ({ open, onOpenChange, track }) => {
  const [f, setF] = useState({ claimant_name: "", claimant_email: "", work_description: "", good_faith: false });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reports/dmca", { ...f, track_id: track.track_id });
      toast.success("Notice received. Our moderation team reviews priority claims within 24h.");
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#12121A] border-white/10" data-testid="dmca-dialog" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Report Copyright / DMCA Claim</DialogTitle>
          <DialogDescription>“{track.title}” by {track.artist?.name}. Notices go to our priority moderation queue.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input data-testid="dmca-name-input" placeholder="Your full legal name" value={f.claimant_name} onChange={(e) => setF({ ...f, claimant_name: e.target.value })} />
          <Input data-testid="dmca-email-input" placeholder="Contact email" type="email" value={f.claimant_email} onChange={(e) => setF({ ...f, claimant_email: e.target.value })} />
          <Textarea data-testid="dmca-description-input" placeholder="Describe the copyrighted work and how it is infringed" rows={4} value={f.work_description} onChange={(e) => setF({ ...f, work_description: e.target.value })} />
          <label className="flex gap-3 items-start text-sm text-zinc-300">
            <Checkbox data-testid="dmca-goodfaith-checkbox" checked={f.good_faith} onCheckedChange={(v) => setF({ ...f, good_faith: !!v })} className="mt-0.5" />
            I state in good faith that this use is not authorized by the rights holder, and the information is accurate.
          </label>
          <Button data-testid="dmca-submit-button" disabled={busy || !f.good_faith} onClick={submit} className="w-full rounded-full bg-red-500 hover:bg-red-600 text-white">Submit notice</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
